import { render } from "./VTabButtons.vue?vue&type=template&id=4a2e1e78&scoped=true"
import script from "./VTabButtons.vue?vue&type=script&lang=js"
export * from "./VTabButtons.vue?vue&type=script&lang=js"

import "./VTabButtons.vue?vue&type=style&index=0&id=4a2e1e78&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2e1e78"]])

export default __exports__